// src/utils/urlUtils.ts

import { type } from "arktype";
import { RoomId } from "../../types";

/**
 * Checks if a string is a valid HTTP or HTTPS URL.
 */
export function isValidRoomId(str: string): boolean {
  return !(RoomId(str) instanceof type.errors);
}

/**
 * Extracts the YouTube video ID from various URL formats.
 */
export function getYoutubeVideoId(url: string): string | null {
  if (!url) return null;
  // Regular expression to match various YouTube URL formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2]?.length === 11 ? match[2] : null;
}

/**
 * Gets the room ID from the current window URL path.
 */
export function getRoomIdFromUrl() {
  // Ensure this runs only on the client-side
  if (typeof window === "undefined") {
    return "";
  }
  let roomId = decodeURIComponent(
    window.location.href.replace(window.location.origin + "/", "")
  );

  const youtubeId = getYoutubeVideoId(roomId);
  if (youtubeId) {
    return "https://www.youtube.com/watch?v=" + youtubeId;
  }
  // strip for trailing slashes
  roomId = roomId.replace(/\/+$/, "");
  return roomId;
}
